// eslint-disable-next-line @typescript-eslint/no-unused-vars -- 'GridColumnHeaderParams' is defined but never used.
import type { GridColDef, GridColumnHeaderParams } from '@mui/x-data-grid';

import {
  green150,
  teal200,
  yellowOrange100,
} from '../../theme/videa-style-tokens';

export const REVENUE = 'revenue';
export const NAME = 'name';
export const ASC = 'asc';
export const DESC = 'desc';
export const PAGE = 'page';
export const LIST = 'list';
export const PAGE_SIZE_TOP_BOTTOM_LOC = 5;
export const DEFAULT_PAGE_SIZE = 15;
export const HOME_LOCATIONS_PAGE_SIZE = 5;
export const LOCATIONS_PAGE_SIZE = 30;
export const DEFAULT_CURRENCY_SYMBOL = '$';

export const CHART_COLORS = [
  { treatmentType: 'CROWNS', colorValue: teal200 },
  { treatmentType: 'FILLINGS', colorValue: green150 },
  { treatmentType: 'OTHER', colorValue: yellowOrange100 },
];

export const FINE_PRINT = 'Case completion rate is 30-day retrospective.';

export const LOCATIONS_PAGE_SIZE_OPTIONS = [15, 30, 50];
